<div
  class="currency-grid"
  [ngClass]="{ 'is-open': isOpen, 'is-closed': !isOpen }"
  >
  <div style="grid-column: 1/-1; margin-bottom: 10px; color: #666">
    <strong data-translation-key="horse_info_currency_conversion_title">
      {{ 'horse_info.currency_conversion_title' | translate }}
      {{
      baseCurrency.amount
      | customCurrency
      : currency?.currency_code
      : locale
      : "symbol"
      : "1.0-0"
      }}
    </strong>
    <button class="close-button" (click)="closeCurrencyPanel()">✕</button>
  </div>

  @for (conversion of currencyArray; track conversion) {
    @if (conversion?.to_currency_code != conversion?.from_currency_code) {
      <div
        class="currency-item"
        >
        <img
          [src]="conversion?.flag"
          [alt]="conversion?.to_currency_code"
          class="flag-icon"
          />
          <span class="amount"
            >{{ conversion.amount | number : "1.2-2" }}
            {{ conversion?.to_currency_code | currencySymbol : locale }}</span
            >
          </div>
        }
      }

      <div
        class="update-time"
        style="grid-column: 1/-1; margin-bottom: 10px; color: #666"
        >
        <em>
          <span
            data-translation-key="horse_info_currency_conversion_approximation_title"
            >
            {{ 'horse_info.currency_conversion_approximation_title' | translate }}
          </span>
          <b>{{ approximationDate | localDateTime : "clockTime" }}</b>

          <span data-translation-key="horse_info_on">
            {{ 'horse_info.on' | translate }}
          </span>
        </em>
        <b>
          {{ approximationDate | localDateTime : "shortDate" }}
        </b>
      </div>
    </div>
